import _ from "lodash";
import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { MediaCard } from "@toddle-edu/ds-web";
import { getIsMessagingWidget, ATTACHMENT_TYPES } from "Utils/MessageHelpers";
import { getThumbUrl } from "Utils";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";
import { useMessageOptions } from "UIComponents/Message/providers/MessageProvider";

import MediaCardWrapper from "AppComponents/Attachment/MediaCardWrapper/MediaCardWrapper";
import classes from "./MultiTypeAttachments.scss";

const attachmentBottomComponent = () => null;

const SingleLinkAttachment = props => {
  const { attachment, onMediaClick } = props;
  const { type, name, url } = attachment;
  const { isPreviewMessagesModal } = useMessageOptions();

  const { thumbUrl } = getThumbUrl({
    attachment: attachment,
    width: 300,
    height: 300,
    fitIn: true,
  });

  const handleClick = () => {
    onMediaClick(attachment);
  };

  return (
    <MediaCard
      mimeType={null}
      thumbUrl={thumbUrl}
      name={name}
      type={type}
      showSubtext
      onClick={isPreviewMessagesModal ? undefined : handleClick}
      cardType="large"
      url={url}
      dsVersion={"2.0"}
    />
  );
};

const MultiTypeAttachments = props => {
  const { attachments, onMediaClick } = props;

  const { screenMode, isPreviewMessagesModal } = useMessageOptions();

  const isMessagingWidget = getIsMessagingWidget({ screenMode });

  const containerClasses = classNames(classes.container, {
    [classes.fullScreenContainer]: !isMessagingWidget,
    [classes.widgetContainer]: isMessagingWidget,
  });

  const autoWrapperClasses = classNames({
    [classes.audioWrapperV2]: true,
    [classes.noPointerEvents]: isPreviewMessagesModal,
  });

  return (
    <div className={containerClasses}>
      {_.map(attachments, attachment => {
        const { id, type } = attachment;

        if (_.size(attachments) === 1 && type === ATTACHMENT_TYPES.LINK) {
          return (
            <SingleLinkAttachment
              key={id}
              attachment={attachment}
              onMediaClick={onMediaClick}
            />
          );
        }

        if (type === ATTACHMENT_TYPES.AUDIO) {
          return (
            <div key={id} className={autoWrapperClasses}>
              <AudioWaveformPlayer
                attachment={attachment}
                audioLoaded={_.noop}
              />
            </div>
          );
        }

        return (
          <div
            key={id}
            className={isPreviewMessagesModal ? classes.noPointerEvents : null}
          >
            <MediaCardWrapper
              dsVersion={"2.0"}
              className={classes.mediaCardWrapper}
              attachment={attachment}
              mediaCardSize="medium"
              mode="view"
              onClickAttachmentCard={
                isPreviewMessagesModal ? undefined : onMediaClick
              }
              attachmentBottomComponent={attachmentBottomComponent}
            />
          </div>
        );
      })}
    </div>
  );
};

MultiTypeAttachments.propTypes = {
  onMediaClick: PropTypes.func.isRequired,
  attachments: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default memo(MultiTypeAttachments);
